import { useQuery } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { queryFnGET } from "api/tanStackQuery/helpers";
import { PartialTrainIdentifier } from "features/CenterContent/VehicleDetails/TrainDetails/useTrainRoute";

export type TrainRouteChangedEventsResponse = {
  uuid: string;
  firstStop: TrainRouteChangedStop;
  lastStop: TrainRouteChangedStop;
};

type TrainRouteChangedStop = {
  ids: Array<TrainRouteChangedStopId>;
};

type TrainRouteChangedStopId = {
  id: string;
  name?: string;
};

export const routeChangedEventsQueryKey = "routeChangedEvents";
export const useRouteChangedEvents = ({
  identifier,
  nominalDate,
  countryCode,
}: PartialTrainIdentifier) => {
  const { status, data, isSuccess } = useQuery({
    queryKey: [routeChangedEventsQueryKey, identifier, nominalDate],
    queryFn: ({ signal }) =>
      queryFnGET<TrainRouteChangedEventsResponse[]>({
        signal,
        url: `${getBackendUrl()}/trainInformation/train/existing-changes/${countryCode ?? "NO"}/${identifier}/${nominalDate}`,
      }),
  });
  return { status, data, isSuccess };
};
